import React from 'react';
import PropTypes from 'prop-types';
function CellHeader({ fcProps }) {
    return React.createElement("span", { className: "cal__num" }, fcProps.dayNumberText);
}
CellHeader.propTypes = {
    fcProps: PropTypes.object.isRequired
};
export default CellHeader;
